export const PHONE_DISPLAY = "0403 210 628";
export const PHONE_TEL = "tel:+61403210628";
export const EMAIL = "damien@leadingedgeconcrete.com.au";
export const EMAIL_MAILTO = `mailto:${EMAIL}`;
export const DIRECTOR = "Damien Baldwin";

export const SERVICES = [
  {
    num: "01",
    title: "Exposed Aggregate",
    blurb:
      "The local favourite finish, done properly. A tough, slip-resistant surface that shows off the natural stone — built for driveways, pool surrounds and paths that cop the summer sun year after year.",
    tags: ["Driveways", "Pool surrounds", "Pathways"],
    img: "/jobs/aggregate-steps.jpg",
  },
  {
    num: "02",
    title: "Honed Concrete",
    blurb:
      "Ground back to a smooth, matte finish with the stone just peeking through. Premium underfoot, cool around pools, and sharp enough for the best alfresco areas going around.",
    tags: ["Pool surrounds", "Alfresco", "Patios"],
    img: "/jobs/pool-surround.jpg",
  },
  {
    num: "03",
    title: "Liquid Limestone",
    blurb:
      "Poured limestone that stays cool underfoot and never shifts or sinks like pavers. A clean, coastal look for pool surrounds, patios and entertaining areas.",
    tags: ["Pool surrounds", "Patios", "Alfresco areas"],
    img: "/jobs/limestone-pool-edge.jpg",
  },
  {
    num: "04",
    title: "Coloured & Grey Concrete",
    blurb:
      "Classic grey or through-coloured mixes matched to your home's palette. Honest, hard-wearing concrete for driveways, crossovers, shed slabs and everything in between.",
    tags: ["Driveways", "Crossovers", "Shed slabs"],
    img: "/jobs/grey-driveway.jpg",
  },
];

export const APPLICATIONS = ["Pool Surrounds", "Patios", "Driveways", "Pathways", "Alfresco Areas"];

export const GALLERY_FILTERS = ["All", "Exposed Aggregate", "Liquid Limestone", "Coloured & Grey", "Outdoor & Pool"];

export const GALLERY = [
  {
    src: "/jobs/pool-surround.jpg",
    type: "Outdoor & Pool",
    label: "Honed white pool surround with glass fencing",
    location: "LEC job",
  },
  {
    src: "/jobs/aggregate-steps.jpg",
    type: "Exposed Aggregate",
    label: "Floating exposed aggregate steps",
    location: "LEC job",
  },
  {
    src: "/jobs/limestone-pool-area.jpg",
    type: "Exposed Aggregate",
    label: "Exposed aggregate pool area",
    location: "LEC job",
  },
  {
    src: "/jobs/limestone-pool-edge.jpg",
    type: "Liquid Limestone",
    label: "Liquid limestone with seamless pool edge",
    location: "LEC job",
  },
  {
    src: "/jobs/limestone-patio.jpg",
    type: "Liquid Limestone",
    label: "Liquid limestone patio area",
    location: "LEC job",
  },
  {
    src: "/jobs/pool-coping.jpg",
    type: "Outdoor & Pool",
    label: "Exposed aggregate — seamless pool edge",
    location: "LEC job",
  },
  {
    src: "/jobs/pool-wide.jpg",
    type: "Outdoor & Pool",
    label: "Pool surround in aggregate finish",
    location: "LEC job",
  },
  {
    src: "/jobs/grey-driveway.jpg",
    type: "Coloured & Grey",
    label: "Grey concrete driveway with saw-cut joints",
    location: "LEC job",
  },
  {
    src: "/jobs/columns-walkway.jpg",
    type: "Exposed Aggregate",
    label: "Exposed aggregate walkway, timber columns",
    location: "LEC job",
  },
  {
    src: "/jobs/white-driveway.jpg",
    type: "Exposed Aggregate",
    label: "Exposed aggregate driveway",
    location: "LEC job",
  },
  {
    src: "/jobs/driveway-crossover.jpg",
    type: "Exposed Aggregate",
    label: "Exposed aggregate driveway & crossover",
    location: "LEC job",
  },
  {
    src: "/jobs/steppers-lawn.jpg",
    type: "Exposed Aggregate",
    label: "Exposed aggregate steppers",
    location: "LEC job",
  },
  {
    src: "/jobs/pool-skimmer.jpg",
    type: "Outdoor & Pool",
    label: "Exposed pool surround, hidden skimmer lid",
    location: "LEC job",
  },
  {
    src: "/jobs/honed-pool-clear.jpg",
    type: "Outdoor & Pool",
    label: "Exposed pool surround with seamless pool edge",
    location: "LEC job",
  },
  {
    src: "/jobs/pool-cover-track.jpg",
    type: "Outdoor & Pool",
    label: "Honed pool area with blanket box",
    location: "LEC job",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Onsite Consultations",
    copy: "Every job starts with a proper look at your site. Damien walks the area with you, talks through finishes and levels, and quotes the real job — not a guess.",
  },
  {
    num: "02",
    title: "Expert Communication & Advice",
    copy: "Twenty-five-plus years in decorative concrete means we've seen it all. We'll tell you honestly what will work on your block, what won't, and why.",
  },
  {
    num: "03",
    title: "On-Time Every Time",
    copy: "Our team leaders, Luca and Luke, keep you in the loop from day one — great communication between you and the team on every job. We turn up when we say we will, and if the weather ever shifts a pour, you'll hear it from us first, with a new plan locked in.",
  },
  {
    num: "04",
    title: "Friendly, Customer-Focused Service",
    copy: "We're a family business, and we treat your home like our own. Straight answers, tidy sites, and a team you'll be happy to have around.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Great communication, friendly service and a great job. Highly recommended.",
    name: "Jill S.",
    location: "East Fremantle",
  },
  {
    quote:
      "Friendly, provided great explanation of product and made some really great suggestions in design.",
    name: "Suzanne",
    location: "Piara Waters",
  },
  {
    quote:
      "Damien was on time, attended site to quote the job and showed recommended products, provided fast responses and did a great job. His work is still looking immaculate.",
    name: "Nathan F.",
    location: "Dayton",
  },
];

export const BUILDERS = ["Aquatechnics", "Riverina", "Barrier Reef Pools"];
export const SUPPLIERS = ["Limecrete", "Holcim", "Hanson"];

export const SWATCHES = [
  { name: "Kajanni White — Exposed", src: "/swatches/kajanni-white-exposed.jpg" },
  { name: "Kajanni White — Honed", src: "/swatches/kajanni-white-honed.jpg" },
  { name: "Kajanni White Fine Blend — Exposed", src: "/swatches/kajanni-white-fine-exposed.jpg" },
  { name: "Kajanni White Fine Blend — Honed", src: "/swatches/kajanni-white-fine-honed.jpg" },
  { name: "Kajanni Grey — Exposed", src: "/swatches/kajanni-grey-exposed.jpg" },
  { name: "Kajanni Grey — Honed", src: "/swatches/kajanni-grey-honed.jpg" },
  { name: "Kajanni Grey Fine Blend — Exposed", src: "/swatches/kajanni-grey-fine-exposed.jpg" },
  { name: "Kajanni Grey Fine Blend — Honed", src: "/swatches/kajanni-grey-fine-honed.jpg" },
];

export const SERVICE_AREAS = [
  "Fremantle",
  "Samson",
  "Bibra Lake",
  "Spearwood",
  "O'Connor",
  "Hamilton Hill",
  "Coogee",
  "Success",
];
